import React, { Component } from 'react'
import './Stores.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import * as storesFunctions from '../../actions/stores'
import { connect } from 'react-redux'
import * as modalAction from '../../actions/modalAction'
import ModalContainer from '../../containers/ModalContainer'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'
import Online from '../../images/connection_online.png'
import Offline from '../../images/connection_offline.png'
import CommonLoader from '../Alerts/CommonLoader'
import { CommonConstants } from '../../Constants'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import NavigationService from '../Common/NavigationServices'
import { checkAccess, getPermission } from '../../actions/permissions'
import { bindActionCreators } from 'redux'
// StoreDetails ( normal user) - Component.
class StoreDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showStores: this.props.showStores,
      language: languageSettings.getCurrentLanguage(),
      stores: {},
      Ascending: false,
      pageSize: 10,
      offset: 0,
      data: [],
      recordCount: 5000,
      userContext: {},
      url: null,
      token: null,
      showCommonLoader: false
    }
    this.navigate = new NavigationService()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.viewDetails = this.viewDetails.bind(this)
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.token = this.authService.getToken()
    this.renderPopUp = this.renderPopUp.bind(this)
    this.checkRegisteredSystem = this.checkRegisteredSystem.bind(this)
  }
  // set View Details
  viewDetails (data) {
    this.props.initStoreDetail(data.Store_UID, false)
  }
  // using react lifecyle method and set the statevalues
  componentWillMount () {
    this.setState({
      stores: this.props.stores
    })
    // Intializing default sort
    this.props.sortStores({ 'sortBy': 'Brand_Name', 'sortType': 'ASC' })
    this.setState({ userContext: this.authService.getProfile() })
  }
  // render the popup component and check the remote connection
  renderPopUp () {
    if (this.props.storeModelPopup !== undefined) {
      return (
        <ModalContainer history={this.props.history} isRemoteConnection={checkAccess(CommonConstants.userPermissions.RemoteConnect)} />
      )
    }
  }
  // Main render function
  render () {
    const { language } = this.state
    let sortParams = this.props.storesDetails.sortParams ? this.props.storesDetails.sortParams : { 'sortBy': 'Brand_Name', 'sortType': 'DESC' }
    let storelistclass = this.state.userContext.IsAccountOwner === 1 && (this.props.subscriptionType === 4 || this.props.subscriptionType === 6) ? 'clientStoreList' : ''
    return (
      <section className={'stores ' + (this.state.showStores ? 'show' : 'hidden')}>
        <div className='settings forms'>
          <div className={'settings_plug ' + storelistclass}>
            <div className='settings_search'>
              <div> <h3>{t[language].storeListStores}</h3> </div>
              <div className='storesButtons'>
                <div>
                  <a href='./stores/grouphierarchy'>
                    {/* Check users isowner and subscription type */}
                    <button className={'additem ' + (this.state.userContext.IsAccountOwner === 1 && (this.props.subscriptionType === 4 || this.props.subscriptionType === 6) ? '' : 'hidden')}>
                      {t[language].managereportgroups}
                    </button></a>
                </div>
              </div>
              {/* Check users isowner and subscription type */}
              <div className={'corpTextSection ' + (this.props.stores.storeDetails.IsCorpUser === 1 ? '' : 'hidden')}><span className='redFontStores'>*</span> <span className='corpText'>{t[language].settingsStoresCorporateStore}</span></div>
            </div>
          </div>
          <div className='settings_list'>
            <div className='storesTable ctable'>
              <Table>
                <Thead>
                  <Tr className='theader clear storesTableHeader'>
                    <Th className='tableHeaders'>&nbsp;</Th>
                    <Th id='brand_space' className={'tableHeaders ' + ((sortParams.sortBy === 'Brand_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Brand_Name' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='Brand_Name' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsHeaderBrand}</span></a></Th>
                    <Th className={'tableHeaders ' + ((sortParams.sortBy === 'Store_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Store_Name' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='Store_Name' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsHeaderStore}</span></a></Th>
                    <Th className={'tableHeaders ' + ((sortParams.sortBy === 'Store_AddressLine1' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Store_AddressLine1' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='Store_AddressLine1' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsHeaderAddress}</span></a></Th>
                    <Th className={'tableHeaders ' + ((sortParams.sortBy === 'Store_Locality' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Store_Locality' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='Store_Locality' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsHeaderCityState}</span></a></Th>
                    <Th className={'tableHeaders ' + ((sortParams.sortBy === 'Group_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Group_Name' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='Group_Name' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsLeaderboardGroup}</span></a></Th>
                    <Th className={'tableHeaders ' + ((sortParams.sortBy === 'GroupName' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'GroupName' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='GroupName' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsReportGroup}</span></a></Th>
                    <Th id='innertable1' className={'tableHeaders ' + ((sortParams.sortBy === 'Device_Name' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Device_Name' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='Device_Name' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsHeaderName}</span></a></Th>
                    <Th id='innertable1' className={'tableHeaders ' + ((sortParams.sortBy === 'Device_MainVersion' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Device_MainVersion' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='Device_MainVersion' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsHeaderVersion}</span></a></Th>
                    <Th id='statusColumn' className={'tableHeaders ' + ((sortParams.sortBy === 'Device_IsActive' && sortParams.sortType === 'ASC') ? 'actcold' : ((sortParams.sortBy === 'Device_IsActive' && sortParams.sortType === 'DESC') ? 'actcol' : ''))}><a><span id='Device_IsActive' onClick={this.sortStores.bind(this)}>{t[language].StoreSettingsHeaderStatus}</span></a></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {/* set loader function before store list */}
                  {!this.state.showCommonLoader ? this.renderStores() : '' }
                </Tbody>
              </Table>
              {this.state.showCommonLoader
                ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''
              }
            </div>
          </div>
        </div>
        {/* calling Popup functions */}
        {this.renderPopUp()}
      </section>
    )
  }
  // set the device status based on device active state.
  renderStatus (device) {
    const { language } = this.state
    if (device.Device_IsActive === 1) {
      // check if the user has Remote Connect access and device is zoom
      if (checkAccess(CommonConstants.userPermissions.RemoteConnect) && device.Device_Name !== 'CIB') {
        return (<span><a style={{ color: parseInt(device.Device_IsActive, 10) === 1 ? 'red' : 'black' }} href={this.navigate.getMenu('connect', device.Device_UID)}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</a></span>)
      } else {
        return (<span style={{ color: 'black' }}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</span>)
      }
    } else {
      // user does not have  Remote Connect access
      return (<span style={{ color: 'black' }}>{device.Device_IsActive ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</span>)
    }
  }
  // Displaying RegisteredSystem
  checkRegisteredSystem (device) {
    let event = this
    const { language } = this.state
    if ((device.Device_Name !== null && device.Device_Name !== undefined) && (device.Device_MainVersion !== null && device.Device_MainVersion !== undefined)) {
      return (
        <div width='100'>
          <img src={Online} className={'cstat ' + (parseInt(device.Device_IsActive, 10) === 1 ? '' : 'hidden')} alt='Device Online' />
          <img src={Offline} className={'cstat ' + (parseInt(device.Device_IsActive, 10) === 0 || !device.Device_IsActive ? '' : 'hidden')} alt='Device Offline' />
          <span className='cstat deviceStatus'>
            {event.renderStatus(device)}
          </span>
        </div>
      )
    } else {
      // Displaying RegisteredSystem is unavailable
      return (<Td className='unavailable' width='100'><span className='cstat deviceStatus'>{t[language].Unavailable}</span></Td>)
    }
  }
  // Displaying stores details
  renderStores () {
    const { language } = this.state
    let self = this
    // get and set the store details
    if (this.props.stores.storeDetails.storeList && this.props.stores.storeDetails.storeList.length > 0) {
      let storeRows = this.props.stores.storeDetails.storeList.map(function (store, index) {
        return (<Tr className='tdata clear'>
          <Td className='storeListviewEditDetails'><a className='opener view_details' onClick={self.viewDetails.bind(this, store)}><span translate='' key='viewedit'>{t[language].viewedit}</span> <br /><span translate='' key='settingsStoresDetails'>{t[language].settingsStoresDetails}</span></a></Td>
          <Td>{store.Brand_Name} <span className={(self.authService.getProfile().User_Company_ID === store.Store_Company_ID && self.props.stores.storeDetails.IsCorpUser) ? '' : 'hidden'}> <span className='redFontStores'> * </span></span></Td>
          <Td>{store.Store_Name || store.Store_Number}</Td>
          <Td>{store.Store_AddressLine1}</Td>
          <Td>{(store.Store_Locality && store.Store_Region) ? store.Store_Locality + ',' + store.Store_Region : (store.Store_Region ? store.Store_Region : store.Store_Locality)}</Td>
          <Td>{store.Group_Name}</Td>
          <Td>{store.GroupName}</Td>
          <Td>{self.renderDeviceName(store.Device_Details)}</Td>
          <Td>{self.renderDeviceVersion(store.Device_Details)}</Td>
          <Td>{self.renderDeviceStatus(store.Device_Details)}</Td>
        </Tr>)
      })
      return storeRows
    } else {
      // display when no stores are avaliable in the store list
      return (
        <Tr className='tdata clear'>
          <Td colSpan='8' className='settings_table_noStores'> <h3>{t[language].settingsStoresNoStores}</h3> </Td>
        </Tr>
      )
    }
  }
  // Get the device name
  renderDeviceName (devices) {
    let deviceRows = devices.map(function (device, index) {
      return (
        <div className='storesColumns' width='90'>{device.Device_Name}</div>
      )
    })
    return deviceRows
  }
  // Get the device version
  renderDeviceVersion (devices) {
    let deviceRows = devices.map(function (device, index) {
      return (
        <div className='storesColumns' width='110'>{device.Device_MainVersion}</div>
      )
    })
    return deviceRows
  }
  // Get the device status
  renderDeviceStatus (devices) {
    let event = this
    let deviceRows = devices.map(function (device, index) {
      return (
        <div className='storesColumns' width='110'>{event.checkRegisteredSystem(device)}</div>
      )
    })
    return deviceRows
  }
  // diplaying device sort order with order conditions
  sortStores (e) {
    // sort stores on sort Icon click
    let Ascending = !this.state.Ascending
    this.setState({ showCommonLoader: true, Ascending })
    let sortBy = e.target.id
    let sortType = this.state.Ascending ? 'DESC' : 'ASC'
    let sortParams = { 'sortBy': sortBy, 'sortType': sortType }
    this.props.sortStores(sortParams)
    this.props.initStoresDetails(() => {
      this.setState({ showCommonLoader: false })
    })
  }
}
// set the state from redux actions
function mapStateToProps (state) {
  return {
    storesDetails: state.storeDetails,
    storeModelPopup: state.StorePopupDetails.storePopUpClient,
    storeModelPopupIsAdmin: state.StorePopupDetails.storePopUpDetailisAdmin
  }
}

function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getPermission: getPermission,
      sortStores: storesFunctions.sortStores,
      initStoresDetails: storesFunctions.initStoresDetails,
      initStoreDetail: modalAction.initStoreDetail
    }, dispatch
  )
}

export default connect(mapStateToProps, matchDispatchToProps)(StoreDetail)



// WEBPACK FOOTER //
// ./src/components/Stores/StoreDetailsClient.js